import styled from 'styled-components';

import LogoImg from '../../assets/imgs/logo.jpg';

export type LogoProps = React.HTMLAttributes<HTMLImageElement>;

export const Element = styled.img`
	max-width: 11.5rem;
	max-height: 2rem;
	height: auto;

	@media (min-width: 319px) {
		max-height: 3rem;
	}

	@media (min-width: 480px) {
		max-height: 4rem;
	}

	@media (min-width: 768px) {
		max-height: 5rem;
	}

	@media (min-width: 992px) {
		max-height: 6rem;
	}
`;

export const Logo: React.FC<LogoProps> = ({ className, ...props }) => (
	<Element
		src={LogoImg}
		alt="BIGGBY COFFEE Logo"
		className={`logo${className ? ` ${className}` : ''}`}
		{...props}
		// style={{
		// 	...style,
		// 	width: undefined,
		// 	height: 'auto'
		// }}
	/>
);
